export class Styles {
	static BackgroundColorGreen = "background-color: #78c172; border-color: rgba(255, 255, 255, 0.4);";
	static BackgroundColorGrey = "background-color: #bfbfbf; border-color: rgba(255, 255, 255, 0.4);";
	static BackgroundColorRed = "background-color: #EF8982; border-color: rgba(255, 255, 255, 0.4);";
	static CursorPointer = "cursor: pointer;";
}

export class Columns {
	static ComponentId = "componentId";
	static Title = "title";
	static ConversationId = "conversationId";
}
